import { createStore } from "@/store/index";
import { createObserver } from "@/utils/observer";
import brandCsrCmpSet from "@/utils/brandCsrCmpSet/toshiba";
import {
  useCartQuantity,
  useInitB2bCallback,
  useLogOut,
  useCustomerName,
  useGetPath,
  useCustomerNameUpdate,
  useGetB2bLoginURL,
  useCartQuantitySubscribe
} from "@/hooks/shopify-hooks/useShopifyMessageEvent";
import { useIsAccessTokenValid } from "@/hooks/shopify-hooks/useShopifyUtils.js";
import FormV3 from "@/components/AEM/form-v3";
import { eleIsExist, getReplaceToken } from "@/utils/common";
import { useExposeCsrContext } from "@/hooks/common/use-expose-csr-context";
import {
  __CONTEXT_FIELD_LOGIN__,
  __CONTEXT_FIELD_LOGOUT__,
  __SHOPIFY_URL__
} from "@/hooks/common/use-expose-csr-context/constants";
import "@/style/index.less";

const {
    renderAllCsrCmp,
    renderAllCsrCmpForce,
    renderCsrCmpManually,
} = brandCsrCmpSet;

// 初始化store
createStore();
createObserver();

// 暴露全局renderAllCsrCmp方法，AEM后台更新组件时调用
window.renderAllCsrCmp = renderAllCsrCmp;
window.renderAllCsrCmpForce = renderAllCsrCmpForce;
window.renderCsrCmpManually = renderCsrCmpManually;

eleIsExist(".form-v3", FormV3.init.call(FormV3));

// useCartBuyerIdentity();

// 当代码执行完时，触发一个方法，通知需要手动渲染dom的地方执行相应的代码
// const csrJsLoadedEvent = new CustomEvent("csr-components-js-loaded");
// window.dispatchEvent(csrJsLoadedEvent);
window?.observer?.dispatch("csr-components-js-loaded");

// 触发购物车数量方法，让header更新数据
useCartQuantity();
// 双向监听，回退刷数header头部上的购物车数量
useCartQuantitySubscribe();

// 触发用户名方法，让header更新数据
useCustomerName();
// 监听用户名方法，让header更新数据
useCustomerNameUpdate();

// 暂时调试b2b登录，直接调用
useInitB2bCallback();

// 绑定是否登录在window.csr.$login中, igws工程可以调用
useExposeCsrContext({
  key: __CONTEXT_FIELD_LOGIN__,
  data: {
    useIsAccessTokenValid: useIsAccessTokenValid,
  },
});

// 绑定退出在window.csr.$logOut中, igws工程可以调用
useExposeCsrContext({
  key: __CONTEXT_FIELD_LOGOUT__,
  data: {
    useLogOut: useLogOut,
  },
});
// 绑定在window.csr.$logOut中, igws工程可以调用
useExposeCsrContext({
  key: __SHOPIFY_URL__,
  data: {
    useGetB2bLoginURL: useGetB2bLoginURL,
  },
});
const { loginPath,loginPathForMobile } = useGetPath();
getReplaceToken(loginPath, loginPathForMobile).finally(() => {
  renderAllCsrCmp();
});